module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [(_vm.artist) ? _c('div', {
    staticClass: "artist"
  }, [_c('prevheader', {
    attrs: {
      "title": _vm.artist.name,
      "styleOpacity": "Opacity"
    }
  }), _vm._v(" "), _c('div', {
    ref: "headerBg",
    staticClass: "prev-headerBg"
  }), _vm._v(" "), _c('div', {
    ref: "avatar",
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.artist.avatar.big,
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.nav),
      expression: "!nav"
    }],
    staticClass: "title-nav title-nav-fixed"
  }, [_c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.hto
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.hto)
      }
    }
  }, [_vm._v("热门50")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.singerInfo
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.singerInfo)
      }
    }
  }, [_vm._v("歌手信息")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.album
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.album)
      }
    }
  }, [_vm._v("专辑")])]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('scroll', {
    ref: "scroll",
    attrs: {
      "probeType": _vm.probeType,
      "listenScroll": true
    },
    on: {
      "scroll": _vm.__scroll
    }
  }, [_c('div', {
    staticClass: "artils-content"
  }, [_c('div', {
    ref: "operation",
    staticClass: "operation"
  }, [_c('span', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.collection(_vm.artist)
      }
    }
  }, [_vm._v(_vm._s(_vm.collectionSwitch ? '已收藏' : '收藏'))])]), _vm._v(" "), _c('ul', {
    staticClass: "title-nav"
  }, [_c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.hto
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.hto)
      }
    }
  }, [_vm._v("热门50")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.singerInfo
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.singerInfo)
      }
    }
  }, [_vm._v("歌手信息")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.album
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.album)
      }
    }
  }, [_vm._v("专辑")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 1),
      expression: "type === 1"
    }],
    staticClass: "notSong search-content"
  }, [_c('songList', {
    attrs: {
      "styles": 3,
      "songs": _vm.notSong
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notSong.length),
      expression: "!notSong.length"
    }]
  }, [_c('loading')], 1)], 1), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === _vm.singerInfo),
      expression: "type === singerInfo"
    }],
    staticClass: "avatarDetail"
  }, [_c('dt', [_vm._v("歌手简介")]), _vm._v(" "), (_vm.avatarDetail) ? _c('dd', _vm._l((_vm.avatarDetail), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), _c('dd', [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.avatarDetail),
      expression: "!avatarDetail"
    }]
  })], 1)])])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ea8b3aa4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/artist.vue
// module id = 216
// module chunks = 1